import {Node} from 'konva/lib/Node'

export function getRelativePointerPosition(node: Node) {
  // the function will return pointer position relative to the passed node
  var transform = node.getStage().getAbsoluteTransform().copy()
  // to detect relative position we need to invert transform
  transform.invert()

  // get pointer (say mouse or touch) position
  var pos = node.getStage().getPointerPosition()

  // now we find relative point
  return transform.point(pos)
}
